import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, Typography, styled } from "@mui/material";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";

const PageWrapper = styled(Box)(() => ({
  minHeight: "100vh",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background:
    "radial-gradient(ellipse at top, rgba(37, 99, 235, 0.25) 0%, rgba(6, 11, 25, 1) 55%), #030712",
  padding: 24,
  boxSizing: "border-box",
}));

const MainCard = styled(Card)(() => ({
  width: "100%",
  maxWidth: 460,
  borderRadius: 16,
  padding: "30px 24px",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  background: "rgba(14, 23, 45, 0.85)",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.35)",
  textAlign: "center",
}));

const IconCircle = styled(Box)(() => ({
  width: 58,
  height: 58,
  borderRadius: "50%",
  margin: "0 auto 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(245, 158, 11, 0.14)",
  border: "1px solid rgba(245, 158, 11, 0.35)",
}));

function VaraVerificationRequestSent() {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <MainCard>
        <IconCircle>
          <AccessTimeRoundedIcon sx={{ color: "#F59E0B", fontSize: 26 }} />
        </IconCircle>

        <Typography sx={{ fontSize: 26, fontWeight: 700, color: "#FFFFFF", mb: 1 }}>
          Verification Request Sent
        </Typography>

        <Typography sx={{ fontSize: 14, lineHeight: "22px", color: "#CBD5E1", maxWidth: 360, mx: "auto" }}>
          Your account has been successfully created. <br />
          Our team is currently reviewing your information. You will be notified once the verification process is complete.
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate("/")}
          sx={{
            mt: 3,
            py: 1.25,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
            bgcolor: "#2563EB",
            "&:hover": { bgcolor: "#1D4ED8" },
          }}
        >
          Go to Home Page
        </Button>
      </MainCard>
    </PageWrapper>
  );
}

export default VaraVerificationRequestSent;
